import { Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import * as React from 'react';
import { useEffect, useRef, useState } from "react";
import { FaFilePdf } from "react-icons/fa6";
import { ColorRing } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ApiCall } from './CustomHooks';
import { CommonApiData, handleDownload, handleShowFile } from './EnvConfig';
import { InputBox } from './InputBox';

export const Table = (
    {
        handleEdit,
        filterData,
        OtherExport = false,
        matchingkey,
        ClickOnLink,
        handleCheck,
        handleCheckAll,
        checkAll,
        showCheckBox,
        handleExport,
        PageName,
        loading = false,
        Filter = true,
        selectedValue,
        setSelectedValue,
        handleChange1,
        currentPageNo,
        setFilterData,
        handleSorting,
        sortConfig,
        handleDelete,
        handleFilter,
        tableData,
        children,
        onlyFilterPage = false,
        checkUnit = false,
        showLink = false,
        isEditTable = false,
        handleViewDetails,
        handleApproval,
        handleGenerate,
        handleFollowUp,
        handleInitiateSalesOrder,
        handlePrint,
        handleIssue,
        handlePrint2,
        handleDownloadZip,
        handleMail,
    }) => {
    const commonData = CommonApiData();
    const unitCode = useSelector((state) => state.header.unitCode);
    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const inputrefs = useRef([]);
    const [ModalData, setModalData] = useState([]);
    const [MainData, setMainData] = useState(tableData?.Data ? tableData?.Data : []);
    const [ModalTitleKey, setModalTitleKey] = useState([]);
    const [ModalHeaderKey, setModalHaderKey] = useState([]);
    const [AdvanceModelCleared, setAdvanceModelCleared] = useState(false);

    const ShowEyeRecords = (data, key) => {
        setModalData(data)
        setModalTitleKey(key)
        setModalHaderKey(Object?.keys(data[0]))
    };

    const FinalHeaderKeys = tableData?.HeadersKey?.length > 0
        ? tableData?.HeadersKey?.filter((key) => !tableData?.HideColumns?.includes(key))
        : Array.from(
            new Set(
                tableData?.Data?.flatMap((data) => Object.keys(data))
                    .filter((columnName) => !tableData?.HideColumns?.includes(columnName))
            )
        );

    const FinalHeadersValue = (tableData?.HeadersKey?.length > 0 && tableData?.HeadersValue?.length > 0)
        ? tableData.HeadersValue.filter((key) => !tableData?.HideColumns?.includes(key))
        : Array.from(
            new Set(
                tableData.Data?.flatMap((data) => Object.keys(data))
                    .filter((columnName) => !tableData?.HideColumns?.includes(columnName))
            )
        );

    const [ColoredRow, setColoredRow] = useState('');

    const handleHighlight = (id, index) => {
        const highlightedId = id !== undefined ? id : index;
        setColoredRow(highlightedId);
    };

    let RequestData = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "PageName": PageName
    };
    const [serchingData, setSerchingData] = useState([]);

    const serching = async () => {
        if (Filter) {
            let data = await ApiCall('/api/AutoComplete/GetSearchingColumn', RequestData)
            setSerchingData(data.getSearchingList)

            if (data.getSearchingList && data.getSearchingList.length > 0) {
                setFilterData({
                    ...filterData,
                    SearchFieldValue: data.getSearchingList[0].searchingValue
                })
            } else {
                setFilterData({
                    ...filterData,
                    SearchFieldValue: ''
                })
            }
        }
    };

    //---------- handle Show file --------//
    const ShowFileHandler = async (value) => {
        handleShowFile({ ...Data, FormName: value.FormName, ID: value.ID, CallType: value.CallType })
    }

    //-------- handle Download file ---------//
    const DownloadFileHandler = async (value) => {
        handleDownload({ ...Data, FormName: value.FormName, ID: value.ID, CallType: value.CallType })
    };

    const handleDownloadExcelFile = async (value) => {
        try {
            let excelResult = await ApiCall('/api/Image/GetImage', { ...Data, FormName: value.FormName, ID: value.ID, CallType: value.CallType });

            if (excelResult?.data?.fileBase64) {
                const base64String = excelResult.data.fileBase64.split(',')[1].trim();
                const contentType = excelResult?.data?.contentType || 'application/octet-stream';
                const dataURI = `data:${contentType};base64,${base64String}`;
                const link = document.createElement("a");
                link.href = dataURI;
                link.download = "data.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error("Base64 string is empty or undefined.");
            }
        } catch (error) {
            console.error("Error while handling download:", error);
        }
    };

    const countNo = Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize))) ? Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize))) : 1;


    // Show Edit Modal
    const draggingCard = useRef();

    const [showEditTableModal, setShowEditTableModal] = useState(false);
    const [searchingEditableHeader, setSearchingEditableHeader] = useState('');
    const [finalHeadersValue, setFinalHeadersValue] = useState([]);
    const [finalHeadersKeys, setFinalHeadersKeys] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(false);
    const [selectedHeader, setSelectedHeader] = useState([]);
    const fixedHeader = ["city"]
    const handleCloseEditTableModal = () => {
        setShowEditTableModal(false)
    }

    const handleCheckBox = (ele, e, index) => {

        setHoveredIndex(null)
        const tempData = {
            headerName: ele,
            sequance: index,
            isFixed: fixedHeader?.includes(ele.replace(" ", "").toLowerCase())
        };
        if (e.target.checked) {
            setSelectedHeader([...selectedHeader, tempData]);
        } else if (selectedHeader.length > 1) {
            const temp = [...selectedHeader];
            const filterdata = temp.filter(item => item.headerName !== ele)
            setSelectedHeader(filterdata);
        }
    }

    const handleSaveEditTableData = () => {
        const updatedKeys = selectedHeader.map(ele => ele.headerName)
        setFinalHeadersValue(updatedKeys);
        setFinalHeadersKeys(updatedKeys);
        handleCloseEditTableModal();
    }


    const handleDragStart = (event, index) => {
        draggingCard.current = index;
    };

    const handleDragEnter = (event, index) => {
        const updatedHeader = [...selectedHeader];
        const moverItem = updatedHeader.splice(draggingCard.current, 1)[0];
        updatedHeader.splice(index, 0, moverItem);
        setSelectedHeader(updatedHeader);
        draggingCard.current = index;
    }

    const handleMoveToTop = (index) => {
        if (index === 0) return;
        const updatedHeader = [...selectedHeader];
        const moverItem = updatedHeader.splice(index, 1)[0];
        updatedHeader.splice(0, 0, moverItem,);
        setSelectedHeader(updatedHeader);
    };

    const handleMoveToBottom = (index) => {
        if (index === selectedHeader.length - 1) return;
        const updatedHeader = [...selectedHeader];
        const moverItem = updatedHeader.splice(index, 1)[0];
        updatedHeader.splice(selectedHeader.length - 1, updatedHeader.length, moverItem);
        setSelectedHeader(updatedHeader);
    };

    const handleRemoveShowHeader = (ele) => {
        if (selectedHeader.length > 1) {
            const temp = [...selectedHeader];
            const filterdata = temp.filter(item => item.headerName !== ele)
            setSelectedHeader(filterdata);
        }
    }

    const resetShowHeaderValues = () => {
        if (finalHeadersValue) {
            setSelectedHeader(FinalHeadersValue.map((ele, i) => ({
                headerName: ele,
                sequance: i,
                isFixed: fixedHeader?.includes(ele.replace(" ", "").toLowerCase())
            })));
        }
    }

    //for  Check boxxxxxxxxx Start..............

    const handleCheckboxChange = (id) => {
        let newSelected;
        if (selectedValue.includes(id)) {
            newSelected = selectedValue?.filter((item) => item !== id);
        } else {
            newSelected = [...selectedValue, id];
        }
        setSelectedValue(newSelected);
    };

    // Handle select all
    const handleSelectAll = () => {
        if (selectedValue?.length === MainData?.length) {
            setSelectedValue([]);
        } else {
            setSelectedValue(MainData?.map((item) => item.CANo));
            setSelectedValue(
                MainData?.filter(item => item.Verify === "UnVerify")
                    .map(item => item.CANo)
            );
        }
    };

    // Check if all are selected
    const isAllSelected = selectedValue?.length === MainData?.length;

    useEffect(() => {
        resetShowHeaderValues();
    }, [tableData.HeadersValue]);

    useEffect(() => {
        serching();
    }, []);

    useEffect(() => {
        setMainData(tableData?.Data)
    }, [tableData]);


    useEffect(() => {
        setFinalHeadersKeys(FinalHeaderKeys)
        setFinalHeadersValue(FinalHeadersValue)
    }, [tableData.Data]);

    useEffect(() => {
        if (AdvanceModelCleared) {
            handleFilter();
            setAdvanceModelCleared(false)
        }
    }, [AdvanceModelCleared]);

    return (
        <>  {
            tableData ? (
                <div className='main-card my-shadow  card border-0 mb-4' >
                    {/* Filter and Advance Filter Icon and paging*/}
                    <div className='card-header mb-1'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-md-4'>
                                <h6 className='m-0 d-flex gap-2'>
                                    <span>{`${tableData?.TotalRecord !== undefined ? 'Total Records : ' + tableData?.TotalRecord : (tableData?.Data?.length ? 'Total Records : ' + tableData?.Data?.length : 'No Record Found')}`}</span>
                                    <span>{showCheckBox && tableData?.Data?.filter(d => d.checkStatus).length > 0 ? `, Selected: ${tableData?.Data?.filter(d => d.checkStatus).length}` : ''}</span>
                                </h6>
                            </div>
                            {Filter ?
                                //Normal Filter Inputs
                                <div className='col-md-8 col-lg-6 d-flex flex-row filters'>
                                    <select
                                        value={filterData?.SearchFieldValue}
                                        onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}
                                        className="form-select me-2 form-control block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none"
                                        aria-label="Default select example">
                                        {Array.isArray(serchingData) && (
                                            serchingData?.map((list, i) => (
                                                <option key={`filterList${i}`} value={list?.searchingValue}> {list?.searchingText}</option>
                                            ))
                                        )}
                                    </select>
                                    <select className="form-select me-2 form-control block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none" aria-label="Condition"
                                        value={filterData?.StartValue} onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}
                                    >
                                        <option value="1">Exactly</option>
                                        <option value="2">Contains</option>
                                        <option value="3">Start With</option>
                                    </select>
                                    <input type="text"
                                        className="form-control search rounded-end-0 form-control block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none"
                                        placeholder="Search"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleFilter()
                                            };
                                        }}
                                        value={filterData?.SearchText}
                                        onChange={(e) => setFilterData({ ...filterData, SearchText: e.target.value })}
                                    />
                                    {/*Normal Filter Button*/}
                                    <button onClick={handleFilter} className="btn rounded-start-0 btn-danger border-0 search-btn text-xs text-white bg-redled-light me-2"><i className="fa-solid fa-magnifying-glass"></i></button>
                                    {/*Page Size DropDown*/}
                                    {
                                        filterData?.PageSize &&
                                        <select className="form-select me-2" aria-label="PageSize" style={{ width: "110px" }}
                                            value={filterData?.PageSize ? filterData?.PageSize : "10"} onChange={(e) => {
                                                setFilterData({ ...filterData, PageSize: e.target.value })
                                                setAdvanceModelCleared(true)
                                            }}
                                        >
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                            <option value="500">500</option>
                                        </select>
                                    }
                                </div>
                                :
                                OtherExport ?
                                    <div className='col-md-8 col-lg-6 flex-row filters'>
                                        <button type="button" className="btn btn-rounded mb-0 btn-warning" style={{ float: 'right' }} name='tblExp'
                                            onClick={handleExport}
                                        >< span className=" text-warning me-2"><i className="fa fa-download text-white color-success"></i>
                                            </span>Export
                                        </button>
                                    </div>
                                    : onlyFilterPage &&
                                    filterData?.PageSize &&
                                    <div className='d-flex  align-items-center' style={{ minWidth: '100px', maxWidth: '150px' }}>
                                        <select className="form-select me-2" aria-label="PageSize" style={{ width: "110px" }}
                                            value={filterData?.PageSize ? filterData?.PageSize : "10"} onChange={(e) => {
                                                setFilterData({ ...filterData, PageSize: e.target.value })
                                                setAdvanceModelCleared(true)
                                            }}
                                        >
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                            <option value="500">500</option>
                                        </select>
                                    </div>
                            }
                        </div>
                    </div>

                    {/* Loader in table*/}
                    {loading ?
                        <><center>
                            <ColorRing
                                visible={true}
                                height="80"
                                width="80"
                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                            />
                        </center></>
                        :
                        /* Table Data*/
                        <div className='card-body order_page'>
                            <div className="table-responsive main-table">
                                <table className="table table-bordered table-striped mb-0">
                                    <thead className='sticky-table-header text-nowrap text-sm'>
                                        <tr className='light-bg'>
                                            {((tableData?.Data && tableData?.Data?.filter(record => record.Actions).length > 0) || (tableData?.Actions && tableData?.Actions.length > 0 && tableData?.Actions?.includes('Checkbox') === false)) &&
                                                <th>Action</th>
                                            }
                                            {tableData?.Data && tableData?.Data[0]?.hasOwnProperty("Checkbox")
                                                &&
                                                <th style={{ width: showCheckBox ? '20px' : '10px' }} key="thActions">
                                                    <input
                                                        className="form-check-input mt-0"
                                                        type="checkbox"
                                                        checked={checkAll}
                                                        onChange={(e) => handleCheckAll(e.target.checked)}
                                                    />
                                                </th>
                                            }

                                            {finalHeadersKeys?.map((th, headIndex) => (
                                                <th key={`th${headIndex || 0}`} style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                        (handleSorting && th !== "Verify") ?
                                                            handleSorting(finalHeadersValue[headIndex]) : ''}
                                                >
                                                    {th === "Verify" && <input
                                                        className="form-check-input mt-0 me-1"
                                                        type="checkbox"
                                                        checked={isAllSelected}
                                                        onChange={handleSelectAll}
                                                        id={headIndex}
                                                    />}
                                                    {th}
                                                    {
                                                        th !== "Verify" &&
                                                        <>
                                                            {
                                                                (sortConfig?.SortColumn !== null
                                                                    && sortConfig?.SortOrder !== null
                                                                    && sortConfig?.SortColumn === finalHeadersValue[headIndex]) ?
                                                                    (
                                                                        <>
                                                                            <i className="fa fa-arrow-up ms-2" style={{ color: sortConfig?.SortOrder !== 'DESC' ? '#d4d4d4' : 'red' }} ></i>
                                                                            <i className="fa fa-arrow-down" style={{ color: sortConfig?.SortOrder !== 'ASC' ? '#d4d4d4' : 'red' }}  ></i>
                                                                        </>
                                                                    )
                                                                    : (
                                                                        <>
                                                                            <i className="fa fa-arrow-up ms-2" style={{ color: '#d4d4d4' }}></i>
                                                                            <i className="fa fa-arrow-down" style={{ color: '#d4d4d4' }}  ></i>
                                                                        </>
                                                                    )
                                                            }
                                                        </>
                                                    }


                                                </th> || <></>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody className='text-sm'>
                                        {MainData?.map((item, bodyIndex) => (
                                            <tr className={`TableTrhover text-nowrap ${ColoredRow === bodyIndex || item.Edit === ColoredRow ? 'activeTd' : ''}`} key={`row${bodyIndex}`} onClick={() => handleHighlight(item.Edit, bodyIndex)} style={{ backgroundColor: showCheckBox && item.Color }}>
                                                {((tableData?.Data && tableData?.Data?.filter(record => record.Actions).length > 0) || (tableData?.Actions && tableData?.Actions.length > 0)) && (
                                                    <td className="" key={`tdAction${bodyIndex}`} style={{ backgroundColor: ColoredRow === bodyIndex || item.Edit === ColoredRow ? 'lightyellow' : '' }}>
                                                        {item.Actions !== undefined ?
                                                            item.Actions?.split(',').map((btn, index) => (
                                                                <span key={index} className='ms-2'>
                                                                    {(btn === 'Edit' && item?.Edit?.trim() !== "") ?
                                                                        <i className="fa-regular cursor-pointer fa-pen-to-square text-success me-2" key={`row${bodyIndex}edit${index}`} title='Edit' onClick={() => handleEdit(item.Edit, item)} />
                                                                        : (<></>)}

                                                                    {(btn === 'Del' && item?.Del?.trim() !== "") ? <i className="fa-regular cursor-pointer fa-trash-can text-danger me-2" title='Delete' key={`row${bodyIndex}del${index}`} onClick={() => handleDelete(item.Del, item)} /> : (<></>)}
                                                                    {(btn === 'View' && item?.View?.trim() !== "") ? <i className="fa-regular cursor-pointer fa-paper-plane text-primary me-2" title='View Details' key={`row${bodyIndex}del${index}`} onClick={() => handleViewDetails(item.View, item)} /> : (<></>)}
                                                                    {(btn === 'MRIssue' && item?.MRIssue?.trim() !== "") ? <i className=" cursor-pointer fa-solid fa fa-share-square text-primary me-2" title='Issue' key={`row${bodyIndex}del${index}`} onClick={() => handleIssue(item.MRIssue, item)} /> : (<></>)}
                                                                    {(btn === 'Print' && item?.Print?.trim() !== "") ? <i className=" cursor-pointer fa-solid fa-print text-primary me-2" title='Print' key={`row${bodyIndex}del${index}`} onClick={() => handlePrint(item.Print, item)} /> : (<></>)}
                                                                    {(btn === 'Print2' && item?.Print?.trim() !== "") ? <i className=" cursor-pointer fa-solid fa-print text-success me-2" title='Print' key={`row${bodyIndex}del${index}`} onClick={() => handlePrint2(item.Print, item)} /> : (<></>)}
                                                                    {(btn === 'Approval' && item?.Approval?.trim() !== "") ? <i className="fa-solid fa-square-check cursor-pointer  text-success me-2" title='Approval' key={`row${bodyIndex}del${index}f`} onClick={() => handleApproval(item.Approval, item)} /> : (<></>)}
                                                                    {(btn === 'Generate' && item?.Generate?.trim() !== "") ? <i className="fa-solid fa-cogs cursor-pointer  text-danger me-2" title='Generate' key={`row${bodyIndex}del${index}f`} onClick={() => handleGenerate(item.Generate, item)} /> : (<></>)}
                                                                    {(btn === 'FollowUp' && item?.FollowUp?.trim() !== "") ? <i className="fa-regular cursor-pointer fa-paper-plane text-primary me-2" title='FollowUp Details' key={`row${bodyIndex}del${index}`} onClick={() => handleFollowUp(item.FollowUp, item)} /> : (<></>)}
                                                                    {(btn === 'Email' && item?.Email?.trim() !== "") ? <i className="fa-regular cursor-pointer fa fa-envelope text-black me-2" title='Email' key={`row${bodyIndex}del${index}`} onClick={() => handleMail(item.Email, item)} /> : (<></>)}
                                                                    {(btn === 'InitiateSalesOrder' && item?.InitiateSalesOrder?.trim() !== "") ? <i className="fa-solid fa-hourglass-start cursor-pointer  text-info me-2" title='InitiateSalesOrder' key={`row${bodyIndex}del${index}Initale`} onClick={() => handleInitiateSalesOrder(item.InitiateSalesOrder, item)} /> : (<></>)}
                                                                    {btn === 'DownloadZip' && item?.DownloadZip?.trim() !== "" && (
                                                                        <i
                                                                            className="fa fa-file-archive text-success me-2 cursor-pointer"
                                                                            title="Download ZIP"
                                                                            onClick={() => handleDownloadZip(item.DownloadZip)}
                                                                        />
                                                                    )}
                                                                    {btn === 'Checkbox' ?
                                                                        <input
                                                                            className="form-check-input mt-0"
                                                                            type="checkbox"
                                                                            checked={item.checkStatus || false}
                                                                            id={item.Checkbox}
                                                                            onChange={(e) => handleCheck(e.target.checked, item.Checkbox, bodyIndex)}
                                                                        />
                                                                        : (<></>)}<i class=""></i>
                                                                </span>
                                                            )) : tableData?.Actions?.map((btn, index) => (
                                                                <span key={index}>
                                                                    {(btn === 'Edit') ? <i className="fa-regular cursor-pointer fa-pen-to-square text-success me-2" key={`row${bodyIndex}edit${index}`} title='Edit' onClick={() => handleEdit(item.Edit, item)} /> : (<></>)}
                                                                    {(btn === 'MRIssue' && item?.MRIssue?.trim() !== "") ? <i className="cursor-pointer fa-solid fa fa-share-square text-primary me-2" title='Issue' key={`row${bodyIndex}del${index}`} onClick={() => handleIssue(item.MRIssue, item)} /> : (<></>)}
                                                                    {(btn === 'Print' && item?.Print?.trim() !== "") ? <i className="cursor-pointer fa-solid fa-print text-primary me-2" title='Print' key={`row${bodyIndex}del${index}`} onClick={() => handlePrint(item.Print, item)} /> : (<></>)}
                                                                    {(btn === 'Print2' && item?.Print?.trim() !== "") ? <i className="cursor-pointer fa-solid fa-print text-success me-2" title='Print' key={`row${bodyIndex}del${index}`} onClick={() => handlePrint2(item.Print, item)} /> : (<></>)}
                                                                    {btn === 'Del' ? <i className="fa-regular cursor-pointer fa-trash-can text-danger me-2" title='Delete' key={`row${bodyIndex}del${index}`} onClick={() => handleDelete(item.Del)} /> : (<></>)}
                                                                    {(btn === 'Approval' && item?.Approval?.trim() !== "") ? <i className="fa-solid fa-square-check cursor-pointer  text-success me-2" title='Approval' key={`row${bodyIndex}del${index}f`} onClick={() => handleApproval(item.Approval, item)} /> : (<></>)}
                                                                    {(btn === 'Generate' && item?.Generate?.trim() !== "") ? <i className="fa-solid fa-cogs cursor-pointer  text-success me-2" title='Generate' key={`row${bodyIndex}del${index}f`} onClick={() => handleGenerate(item.Generate, item)} /> : (<></>)}
                                                                    {(btn === 'InitiateSalesOrder' && item?.InitiateSalesOrder?.trim() !== "") ? <i className="fa-solid fa-hourglass-start cursor-pointer  text-info me-2" title='InitiateSalesOrder' key={`row${bodyIndex}del${index}Initale`} onClick={() => handleInitiateSalesOrder(item.InitiateSalesOrder, item)} /> : (<></>)}
                                                                    {(btn === 'FollowUp' && item?.FollowUp?.trim() !== "") ? <i className="fa-regular cursor-pointer fa-paper-plane text-primary me-2" title='FollowUp Details' key={`row${bodyIndex}del${index}`} onClick={() => handleFollowUp(item.FollowUp, item)} /> : (<></>)}
                                                                    {(btn === 'Email' && item?.Email?.trim() !== "") ? <i className="fa-regular cursor-pointer fa fa-envelope text-black me-2" title='Email' key={`row${bodyIndex}del${index}`} onClick={() => handleMail(item.Email, item)} /> : (<></>)}
                                                                    {btn === 'Checkbox' ?
                                                                        <input
                                                                            className="form-check-input mt-0"
                                                                            type="checkbox"
                                                                            checked={item.checkStatus || false}
                                                                            id={item.Checkbox}
                                                                            onChange={(e) => handleCheck(e.target.checked, item.Checkbox, bodyIndex)}
                                                                        />
                                                                        : (<></>)}

                                                                </span>
                                                            ))
                                                        }
                                                    </td>
                                                )}
                                                {
                                                    tableData?.Data && tableData?.Data[0]?.hasOwnProperty("Checkbox") && tableData?.Actions.includes('Checkbox') === false &&
                                                    <td className='text-center'>
                                                        <input
                                                            className="form-check-input mt-0"
                                                            type="checkbox"
                                                            checked={item.checkStatus || false}
                                                            id={item.Checkbox}
                                                            onChange={(e) => handleCheck(e.target.checked, item.Checkbox, bodyIndex)}
                                                        />
                                                    </td>
                                                }

                                                {finalHeadersValue?.map((key, tdIndex) =>
                                                    (typeof (item[key]) === 'object') ? (
                                                        Array?.isArray(item[key]) ?
                                                            (item[key].length > 0 ?
                                                                <td key={`key${tdIndex}`}>
                                                                    <i className="fa fa-eye"
                                                                        data-bs-toggle="modal" data-bs-target="#exampleModal"
                                                                        style={{ cursor: 'pointer', color: '#5a8dee' }}
                                                                        onClick={() => ShowEyeRecords(item[key], key)}
                                                                    />
                                                                </td> : <td key={`key${tdIndex}`}></td>) : (
                                                                typeof (item[key]) === 'object' && item[key]?.FileType === 'pdf' ?
                                                                    <td key={`key${tdIndex}`}>
                                                                        <FaFilePdf title='open PDF'
                                                                            className='me-2'
                                                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}
                                                                            onClick={() => { ShowFileHandler(item[key]) }}
                                                                        />
                                                                        <i className='fa fa-download'
                                                                            title='Download'
                                                                            onClick={() => { DownloadFileHandler(item[key]) }}
                                                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }} />
                                                                    </td> :
                                                                    typeof (item[key]) === 'object' && item[key]?.FileType === 'xlsx' ?
                                                                        <td key={`key${tdIndex}`} onClick={() => { handleDownloadExcelFile(item[key]) }}>
                                                                            <FaFilePdf title='Download Excel' style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }} />
                                                                        </td> :

                                                                        typeof (item[key]) === 'object' && !item[key]?.FileType ? (<td key={`key${tdIndex}`}></td>) :
                                                                            (<td key={`key${tdIndex}`} >
                                                                                <i className="fa fa-image me-2"
                                                                                    title='show Image'
                                                                                    onClick={() => { ShowFileHandler(item[key]) }}
                                                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                                                />
                                                                                <i className='fa fa-download'
                                                                                    title='Download'
                                                                                    onClick={() => { DownloadFileHandler(item[key]) }}
                                                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }} />
                                                                            </td>
                                                                            )
                                                            )
                                                    ) :
                                                        matchingkey !== key ?
                                                            (
                                                                item[key] === "UnVerify" ?
                                                                    <td key={`key${tdIndex}`} style={{ backgroundColor: ColoredRow === bodyIndex || item.Edit === ColoredRow ? 'lightyellow' : '' }}>
                                                                        <input
                                                                            className="form-check-input mt-0"
                                                                            type="checkbox"
                                                                            id={item.CANo}
                                                                            checked={selectedValue?.includes(item.CANo)}
                                                                            onChange={() => handleCheckboxChange(item.CANo)}
                                                                        />
                                                                    </td>
                                                                    :
                                                                    <td key={`key${tdIndex}`} style={{ backgroundColor: ColoredRow === bodyIndex || item.Edit === ColoredRow ? 'lightyellow' : '' }}>{item[key]}</td>
                                                            )
                                                            : showLink ? <td key={`key${tdIndex}`} title='Link' style={{ backgroundColor: ColoredRow === bodyIndex || item.Edit === ColoredRow ? 'lightyellow' : '' }}>
                                                                {unitCode === item.Unit && checkUnit ? <Link to='' className='matching_key' style={{ textDecoration: "none", color: 'var(--text)', textShadow: ".7px .3px #5a8dee", fontSize: '13px' }} onClick={() => ClickOnLink(item[key])} >{item[key]}</Link> : item[key]}
                                                            </td> :
                                                                <td key={`key${tdIndex}`} title='Link' style={{ backgroundColor: ColoredRow === bodyIndex || item.Edit === ColoredRow ? 'lightyellow' : '' }}>
                                                                    {
                                                                        item[key] === "Verified" ?
                                                                            <span className='matching_key' style={{ textDecoration: "none", backgroundColor: "#dcfce7", color: '#22c55e', fontSize: '10px', fontWeight: "bold", padding: "2px 8px", border: "1px solid #22c55e", borderRadius: "8px" }}  >{item[key]}</span>
                                                                            :
                                                                            item[key] === "Un-Verified" ?
                                                                                <span
                                                                                    className='matching_key'
                                                                                    style={{ textDecoration: "none", backgroundColor: "#fee2e2", color: '#ef4444', fontSize: '10px', fontWeight: "bold", padding: "2px 8px", border: "1px solid #ef4444", borderRadius: "8px" }}
                                                                                >{item[key]}</span>
                                                                                :
                                                                                item[key] === "Submitted" ?
                                                                                    <span className='matching_key' style={{ textDecoration: "none", backgroundColor: "#fce7f3", color: '#ec4899', fontSize: '10px', fontWeight: "bold", padding: "2px 8px", border: "1px solid #ec4899", borderRadius: "8px" }}  >{item[key]}</span>
                                                                                    :

                                                                                    item[key] === "Revisit Required" ?
                                                                                        <span className='matching_key'
                                                                                            style={{ textDecoration: "none", backgroundColor: "#fee2e2", color: '#ef4444', fontSize: '10px', fontWeight: "bold", padding: "2px 8px", border: "1px solid #ef4444", borderRadius: "8px" }}
                                                                                        >{item[key]}</span>
                                                                                        :
                                                                                        item[key] === "Assigned" ?
                                                                                            <span className='matching_key'
                                                                                                style={{ textDecoration: "none", backgroundColor: "#fef9c3", color: '#eab308', fontSize: '10px', fontWeight: "bold", padding: "2px 8px", border: "1px solid #eab308", borderRadius: "8px" }}
                                                                                            >{item[key]}</span>
                                                                                            :
                                                                                            <span className='matching_key' style={{ textDecoration: "none", color: '#0000FF', fontSize: '15px', cursor: "pointer" }} onClick={() => ClickOnLink(item[key])} >{item[key]}</span>

                                                                    }
                                                                </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {countNo > 1 ?
                                < Pagination className='pt-2' count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange1} shape="rounded" />
                                : ''}
                        </div>
                    }
                    {/* Modal Eye Icon Table Data in Array of Object format*/}

                    <div className="modal modal-xl fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content" style={{ background: 'white' }}>
                                <div className="modal-header" style={{ padding: '7px 15px' }}>
                                    <h5 className="modal-title" id="exampleModalLabel">{ModalTitleKey ? ModalTitleKey : 'Show Records'}</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body table-responsive" style={{ maxHeight: '310px', padding: '8px' }}>
                                    <table className="table border">
                                        <thead>
                                            <tr className='light-bg'>
                                                {ModalHeaderKey?.map((th, headIndex) => (
                                                    <th key={`th${headIndex || 0}`} style={{ padding: '5px 10px', background: 'var(--light-background)' }}>{th}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ModalData?.map((item, bodyIndex) => (
                                                <tr className="TableTrhover" key={`row${bodyIndex}`} >
                                                    {ModalHeaderKey?.map((key, tdIndex) => (
                                                        <td key={`key${tdIndex}`}>{item[key]}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <>
                                    <Dialog
                                        open={showEditTableModal}
                                        onClose={handleCloseEditTableModal}
                                        aria-labelledby="alert-dialog-title"
                                        aria-describedby="alert-dialog-description"
                                        sx={{
                                            "& .MuiDialog-container": {
                                                "& .MuiPaper-root": {
                                                    width: "100%",
                                                    maxWidth: "900px",
                                                }
                                            },
                                            "& .css-hz1bth-MuiDialog-container": {
                                                alignItems: 'start'
                                            }
                                        }}
                                    >
                                        <DialogTitle id="alert-dialog-title" className='py-1 px-2 border-bottom d-flex justify-content-between'>
                                            <div style={{ fontWeight: 700 }}>Edit Columns</div>
                                            <div style={{ fontWeight: 500, cursor: 'pointer' }} title='close'>
                                                <i className='fa-solid fa-xmark' onClick={handleCloseEditTableModal} />
                                            </div>
                                        </DialogTitle>
                                        <DialogContent className='main-card py-2 m-0' style={{ boxShadow: 'none' }}>
                                            <div className='row'>
                                                <div className='col-6 border-end'>
                                                    <InputBox
                                                        id='Search Header'
                                                        inputrefs={inputrefs}
                                                        placeholder='Search'
                                                        divclassname="col-12 pe-0 mb-1"
                                                        value={searchingEditableHeader}
                                                        onChange={(e) => {
                                                            setSearchingEditableHeader(e.target.value);
                                                        }}
                                                    />
                                                    <div className='col-12' style={{ maxHeight: "70vh", overflowY: 'auto' }}>
                                                        {FinalHeadersValue?.filter(ele => ele.toLowerCase().includes(searchingEditableHeader.toLowerCase())).map((ele, index) => {
                                                            return (
                                                                <div key={index} className='arrow'>
                                                                    <input
                                                                        id={`HeaderEditable_${index}`}
                                                                        disabled={fixedHeader?.includes((ele.replace(" ", "").toLowerCase())) ? true : false} className='me-2'
                                                                        type='checkbox'
                                                                        checked={selectedHeader.some(item => item.headerName === ele)}
                                                                        onChange={(e) => handleCheckBox(ele, e, index)}
                                                                    />
                                                                    <label htmlFor={`HeaderEditable_${index}`}>{ele}</label>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                                <div className='col-6' style={{ maxHeight: "75vh", overflowY: 'auto', fontSize: '12px' }}>
                                                    {selectedHeader && selectedHeader?.map((ele, i) => {
                                                        return (
                                                            <div className='m-1 align-content-center d-flex justify-content-between draggable' key={i}
                                                                onMouseEnter={() => {
                                                                    setHoveredIndex(i);
                                                                }}
                                                                onMouseLeave={() => {
                                                                    setHoveredIndex(null);
                                                                }}
                                                                onDragStart={(e) => handleDragStart(e, i)}
                                                                onDragOver={(e) => e.preventDefault()}
                                                                onDragEnter={(e) => handleDragEnter(e, i)}
                                                                draggable
                                                            >
                                                                <span className='m-0'>
                                                                    <i className="fa-solid fa-grip-vertical me-2" /> {ele.headerName}
                                                                </span>
                                                                <span className='d-flex justify-content-between align-items-center gap-2'>
                                                                    {hoveredIndex === i && <>
                                                                        <Tooltip placement="top" title="Move to Bottom">
                                                                            <label
                                                                                className='form-label arrow text-decoration-underline'
                                                                                onClick={() => handleMoveToBottom(i)} style={{ cursor: 'pointer' }}>
                                                                                <i className="fa-solid fa-down-long"></i>
                                                                            </label>
                                                                        </Tooltip>
                                                                        <Tooltip placement="top" title="Move to Top">
                                                                            <label
                                                                                className='form-label arrow text-decoration-underline'
                                                                                onClick={() => handleMoveToTop(i)} style={{ cursor: 'pointer' }}>
                                                                                <i className="fa-solid fa-up-long" ></i>
                                                                            </label>
                                                                        </Tooltip>
                                                                    </>
                                                                    }
                                                                    {ele.isFixed === false &&
                                                                        <i
                                                                            style={{ cursor: 'pointer' }}
                                                                            title='remove'
                                                                            className='fa fa-close'
                                                                            onClick={() => { handleRemoveShowHeader(ele.headerName) }} />
                                                                    }
                                                                </span>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </DialogContent>
                                        <DialogActions className='main-card py-0 pt-1 my-0 px-1' style={{ boxShadow: 'none' }}>
                                            <div className='d-flex justify-content-between align-items-center py-2 w-100'>
                                                <button type="button" name={'btn1'}
                                                    style={{ fontSize: '13px' }}
                                                    onClick={resetShowHeaderValues}
                                                    className="btn btn-rounded btn-warning">
                                                    <span className="text-white me-1" style={{ fontSize: '12px' }}>
                                                        <i className="fa fa-undo color-warning">
                                                        </i>
                                                    </span>Restore default</button>

                                                <button type="button" name={'btn'}
                                                    style={{ fontSize: '13px' }}
                                                    onClick={handleSaveEditTableData}
                                                    className="btn btn-rounded btn-success">
                                                    <span className="text-white me-2" style={{ fontSize: '12px' }}>
                                                        <i className="fa fa-save color-warning">
                                                        </i>
                                                    </span>Save</button>
                                            </div>
                                        </DialogActions>
                                    </Dialog>
                                </>
                            </div>
                        </div>
                    </div>
                </div>

            ) : (<h5>No Record Found !</h5>)
        }
            {children}
        </>
    )
}